import { createContext, useContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
/**
 * Context used for sending actions from within the timeline
 *
 * @param {function} handleTimelineAction  the callback passed in that handles sending data
 *
 * @callback handleTimelineAction
 * @param {string} actionType              the type of action to process
 * @param {Object} data                    the data used for the action, varies in shape by actionType
 */
export const TimelineActionHandlerContext = /*#__PURE__*/createContext(emptyFunction);
export const useTimelineActionHandlerContext = () => useContext(TimelineActionHandlerContext);